import { createSlice } from '@reduxjs/toolkit';
import { isEqual } from 'lodash';

const bim360integrationSlice = createSlice({
  name: 'bim360integration',
  initialState: {
    linkedProjects: [],
    project_operations: [],
    bim360Projects: [],
    apeProjects: [],
  },
  reducers: {
    updateLinkedProject(state, action) {
      const { index, ...propertiesToMerge } = action.payload;
      let linkedProject = state.linkedProjects[action.payload.index];
      state.linkedProjects[action.payload.index] = {
        ...linkedProject,
        ...propertiesToMerge,
      };
    },
    updateLinkedProjectConfig(state, action) {
      const { index, ...propertiesToMerge } = action.payload;
      let linkedProject = state.linkedProjects[action.payload.index];
      let newConfig = {
        ...linkedProject.dirty_config,
        ...propertiesToMerge,
      };

      const existingOperationIndex = state.project_operations.findIndex(
        operation =>
          operation.ape_mobile_project_id === linkedProject.apeProject.id &&
          operation.bim360_project_id === linkedProject.bim360Project.id
      );
      if (!isEqual(newConfig, linkedProject.original_config)) {
        state.linkedProjects[action.payload.index].dirty_config = newConfig;
        if (existingOperationIndex === -1) {
          // The user has specified settings that do not match the original config,
          // so push a new update operation if there are no existing operations
          state.project_operations.push({
            operation: 'update',
            ape_mobile_project_id: linkedProject.apeProject.id,
            bim360_project_id: linkedProject.bim360Project.id,
          });
        }
      } else {
        if (existingOperationIndex > -1) {
          // The user has specified settings that match the server settings,
          // so remove any pending operations
          state.project_operations.splice(existingOperationIndex, 1);
          state.linkedProjects[action.payload.index].dirty_config = undefined;
        }
      }
    },
    addLinkedProject(state, action) {
      const { apeProject, bim360Project, bim360Folder } = action.payload;
      const existingOperationIndex = state.project_operations.findIndex(
        operation =>
          operation.ape_mobile_project_id === apeProject.id &&
          operation.bim360_project_id === bim360Project.id
      );

      if (existingOperationIndex > -1) {
        state.project_operations.splice(existingOperationIndex, 1);
      } else {
        state.project_operations.push({
          operation: 'link',
          ape_mobile_project_id: apeProject.id,
          bim360_project_id: bim360Project.id,
        });
      }
      state.linkedProjects.push({
        isDirty: existingOperationIndex === -1,
        dirty_config: {
          bim360_folder: bim360Folder,
          sync_all_templates: true,
          templates_to_upload: [],
        },
        ...action.payload,
      });
    },
    unlinkProject(state, action) {
      const linkedProject = state.linkedProjects[action.payload.index];
      const existingOperationIndex = state.project_operations.findIndex(
        operation =>
          operation.ape_mobile_project_id === linkedProject.apeProject.id &&
          operation.bim360_project_id === linkedProject.bim360Project.id
      );

      if (linkedProject.isDirty || existingOperationIndex > -1) {
        state.project_operations.splice(existingOperationIndex, 1);
      }

      if (!linkedProject.isDirty) {
        state.project_operations.splice(existingOperationIndex, 1);
        state.project_operations.push({
          operation: 'unlink',
          ape_mobile_project_id: linkedProject.apeProject.id,
          bim360_project_id: linkedProject.bim360Project.id,
        });
      }

      state.linkedProjects.splice(action.payload.index, 1);
    },
    updateExternalSystemId(state, action) {
      state.externalSystemId = action.payload;
    },
    pushExistingLinkedProject(state, action) {
      state.linkedProjects.push(action.payload);
    },
    updateApeProjects(state, action) {
      state.apeProjects = action.payload;
    },
    updateBim360Projects(state, action) {
      state.bim360Projects = action.payload;
    },
  },
});

export const {
  updateLinkedProject,
  updateLinkedProjectConfig,
  addLinkedProject,
  unlinkProject,
  updateExternalSystemId,
  pushExistingLinkedProject,
  updateApeProjects,
  updateBim360Projects,
} = bim360integrationSlice.actions;

export default bim360integrationSlice.reducer;
